export default function loadVimeoApi() {
  return new Promise((resolve) => {
    if (typeof window.Vimeo !== 'undefined') {
      resolve();
      return;
    }

    const tag = document.createElement('script');
    tag.src = 'https://player.vimeo.com/api/player.js';
    tag.onload = () => {
      resolve();
    };

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  });
}
